var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationalArticles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 0L22 0.0183333V18.3333L21.9817 18.315L13.75 18.3333L11.9167 19.25H10.0833L8.25 18.3333L0.0183333 18.315L0 18.3333V0.0183333L8.25 0L10.0833 0.916667H11.9167L13.75 0ZM20.1667 16.5V1.83333H13.75L11.9167 2.75V17.4167L13.75 16.5H20.1667ZM13.75 8.24991V10.0832H17.4167V8.24991H13.75ZM13.75 13.7499V11.9166H18.3333V13.7499H13.75ZM13.75 4.58324V6.41657H18.3333V4.58324H13.75ZM10.0833 17.4167V2.75L8.25 1.83333H1.83333V16.5H8.25L10.0833 17.4167ZM3.66667 8.24991V10.0832H8.25V8.24991H3.66667ZM3.66667 13.7499V11.9166H7.33333V13.7499H3.66667ZM3.66667 4.58324V6.41657H8.25V4.58324H3.66667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationalArticles);
export default __webpack_public_path__ + "static/media/EducationalArticles.b8b20fed379f22eb3860eb6ed04d057d.svg";
export { ForwardRef as ReactComponent };